<template>
  <div v-if="data.registro && data.dados.datas"
       class="impressao_casamento impressao--frente impressao--tamanho_14">
    <div class="impressao_casamento--header">
      <div class="row">
        <div class="impressao_casamento--selo">
          <div>
            <u>https://selodigital.tjsp.jus.br</u>.
          </div>
          <div style="letter-spacing: -1px;">
            Selo Digital: {{ data.selo.selo_digital || '0000000000000000000000000' }}
          </div>
        </div>
      </div>
      <div class="row align-items-end text-center justify-content-left">
        <div class="col-2 m-0 p-0">
          <div class="impressao_casamento--selo">
            <div>
              <img :src="qrCodeImg"
                   class="qrcode"
                   alt="">
            </div>
          </div>
        </div>
        <div class="col-8 m-0 p-0">
          <div class="impressao_casamento--title bold">
            CERTIDÃO DE CASAMENTO
          </div>
        </div>
      </div>
    </div>
    <div class="impressao_casamento--body">
      <div class="impressao_casamento--nomes mt-3">
        <div v-for="(pessoa, index) in data.registro.pessoas"
             :key="index"
             class="row">
          <div class="col-8 mb-2">
            <fieldset class="fieldset-impressao">
              <legend>NOME ATUAL DO CÔNJUGE</legend>
              <span class="bold">{{ pessoa.nome || pessoa.nome_antigo }}</span>
            </fieldset>
          </div>
          <div class="col-4">
            <fieldset class="fieldset-impressao text-center">
              <legend>NÚMERO DO CPF</legend>
              <span class="bold">{{ pessoa.cpf ? maskCPF(pessoa.cpf) : 'NÃO CONSTA' }}</span>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="impressao_casamento--matricula text-center pt-2">
        <div class="text-center font-12 bold">
          Matrícula
        </div>
        <div class="bold">
          {{ data.registro.matricula | maskMatricula }}
        </div>
      </div>

      <div class="impressao_casamento--dados">
        <div class="row">
          <div class="col-8 pr-0">
            <fieldset class="fieldset-impressao">
              <legend>1º CÔNJUGE</legend>
              <span class="text-justify bold">
                {{ data.registro.pessoas.at(0).nome_antigo || 'NÃO CONSTA' }}
              </span>
            </fieldset>
          </div>
          <div class="col-4 d-inline-flex justify-content-between pl-0">
            <div class="col-4 m-0 p-0">
              <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                <legend class="text-center">
                  DIA
                </legend>
                <span class="bold">{{ (`${data.registro.pessoas.at(0).nascimento_dia}`.length == 1 && '0' + data.registro.pessoas.at(0).nascimento_dia || data.registro.pessoas.at(0).nascimento_dia) || 'N/C' }}</span>
              </fieldset>
            </div>
            <div class="col-4 m-0 p-0">
              <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                <legend class="text-center">
                  MÊS
                </legend>
                <span class="bold">{{ (`${data.registro.pessoas.at(0).nascimento_mes}`.length == 1 && '0' + data.registro.pessoas.at(0).nascimento_mes || data.registro.pessoas.at(0).nascimento_mes) || 'N/C' }}</span>
              </fieldset>
            </div>
            <div class="col-4 m-0 p-0">
              <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                <legend class="text-center">
                  ANO
                </legend>
                <span class="bold">{{ (`${data.registro.pessoas.at(0).nascimento_ano}`.length == 1 && '0' + data.registro.pessoas.at(0).nascimento_ano || data.registro.pessoas.at(0).nascimento_ano) || 'N/C' }}</span>
              </fieldset>
            </div>
          </div>
        </div>
      </div>

      <div class="impressao_casamento--dados">
        <div class="row">
          <div class="col-12 d-flex p-0 m-0">
            <div class="col-2 pr-0 m-0">
              <fieldset class="fieldset-impressao">
                <legend>NACIONALIDADE</legend>
                <span class="text-justify bold">
                  {{ data.registro.pessoas.at(0).nacionalidade_conjuge_0 || 'NÃO CONSTA' }}
                </span>
              </fieldset>
            </div>

            <div class="col-2 p-0 m-0">
              <fieldset class="fieldset-impressao ml-2">
                <legend>ESTADO CIVIL</legend>
                <span class="text-justify bold">
                  {{ data.registro.pessoas.at(0).estado_civil || 'NÃO CONSTA' }}
                </span>
              </fieldset>
            </div>

            <div class="col-6 p-0 m-0">
              <fieldset class="fieldset-impressao ml-2 municipio_nascimento">
                <legend>MUNICÍPIO DA NATURALIDADE</legend>
                <span class="text-justify bold">
                  {{ data.registro.pessoas.at(0).naturalidade || 'NÃO CONSTA' }}
                </span>
              </fieldset>
            </div>

            <div class="col-2">
              <fieldset class="fieldset-impressao municipio_nascimento_uf text-center">
                <legend class="text-center">
                  UF
                </legend>
                <span class="text-justify bold">
                  {{ data.registro.pessoas.at(0).uf || 'N/C' }}
                </span>
              </fieldset>
            </div>
          </div>
        </div>
      </div>

      <div class="impressao_casamento--dados">
        <div class="row">
          <div class="col-12">
            <fieldset class="fieldset-impressao">
              <legend>GENITOR(ES)</legend>
              <span class="text-justify bold"
                    v-html="data.registro.pessoas.at(0).genitores_conjuge_0" />
            </fieldset>
          </div>
        </div>
      </div>

      <div class="impressao_casamento--dados">
        <div class="row">
          <div class="col-12">
            <fieldset class="fieldset-impressao">
              <legend>NOME QUE O PASSOU A UTILIZAR</legend>
              <span class="text-justify bold"
                    v-html="data.dados.conjuges.at(0).nome_novo" />
            </fieldset>
          </div>
        </div>
      </div>

      <div class="impressao_casamento--dados mt-3">
        <div class="row">
          <div class="col-8 pr-0">
            <fieldset class="fieldset-impressao">
              <legend>2º CÔNJUGE</legend>
              <span class="text-justify bold">
                {{ data.registro.pessoas.at(1).nome_antigo || 'NÃO CONSTA' }}
              </span>
            </fieldset>
          </div>
          <div class="col-4 d-inline-flex justify-content-between pl-0">
            <div class="col-4 m-0 p-0">
              <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                <legend class="text-center">
                  DIA
                </legend>
                <span class="bold">{{ (`${data.registro.pessoas.at(1).nascimento_dia}`.length == 1 && '0' + data.registro.pessoas.at(1).nascimento_dia || data.registro.pessoas.at(1).nascimento_dia) || 'N/C' }}</span>
              </fieldset>
            </div>
            <div class="col-4 m-0 p-0">
              <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                <legend class="text-center">
                  MÊS
                </legend>
                <span class="bold">{{ (`${data.registro.pessoas.at(1).nascimento_mes}`.length == 1 && '0' + data.registro.pessoas.at(1).nascimento_mes || data.registro.pessoas.at(1).nascimento_mes) || 'N/C' }}</span>
              </fieldset>
            </div>
            <div class="col-4 m-0 p-0">
              <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                <legend class="text-center">
                  ANO
                </legend>
                <span class="bold">{{ (`${data.registro.pessoas.at(1).nascimento_ano}`.length == 1 && '0' + data.registro.pessoas.at(1).nascimento_ano || data.registro.pessoas.at(1).nascimento_ano) || 'N/C' }}</span>
              </fieldset>
            </div>
          </div>
        </div>
      </div>

      <div class="impressao_casamento--dados">
        <div class="row">
          <div class="col-12 d-flex p-0 m-0">
            <div class="col-2 pr-0 m-0">
              <fieldset class="fieldset-impressao">
                <legend>NACIONALIDADE</legend>
                <span class="text-justify bold">
                  {{ data.registro.pessoas.at(1).nacionalidade_conjuge_1 || 'NÃO CONSTA' }}
                </span>
              </fieldset>
            </div>

            <div class="col-2 p-0 m-0">
              <fieldset class="fieldset-impressao ml-2">
                <legend>ESTADO CIVIL</legend>
                <span class="text-justify bold">
                  {{ data.registro.pessoas.at(1).estado_civil || 'NÃO CONSTA' }}
                </span>
              </fieldset>
            </div>

            <div class="col-6 p-0 m-0">
              <fieldset class="fieldset-impressao ml-2 municipio_nascimento">
                <legend>MUNICÍPIO DA NATURALIDADE</legend>
                <span class="text-justify bold">
                  {{ data.registro.pessoas.at(1).naturalidade || 'NÃO CONSTA' }}
                </span>
              </fieldset>
            </div>

            <div class="col-2">
              <fieldset class="fieldset-impressao municipio_nascimento_uf text-center">
                <legend class="text-center">
                  UF
                </legend>
                <span class="text-justify bold">
                  {{ data.registro.pessoas.at(1).uf || 'N/C' }}
                </span>
              </fieldset>
            </div>
          </div>
        </div>
      </div>

      <div class="impressao_casamento--dados">
        <div class="row">
          <div class="col-12">
            <fieldset class="fieldset-impressao">
              <legend>GENITOR(ES)</legend>
              <span class="text-justify bold"
                    v-html="data.registro.pessoas.at(1).genitores_conjuge_1" />
            </fieldset>
          </div>
        </div>
      </div>

      <div class="impressao_casamento--dados">
        <div class="row">
          <div class="col-12">
            <fieldset class="fieldset-impressao">
              <legend>NOME QUE O PASSOU A UTILIZAR</legend>
              <span class="text-justify bold"
                    v-html="data.dados.conjuges.at(1).nome_novo" />
            </fieldset>
          </div>
        </div>
      </div>

      <div class="impressao_casamento--datas mt-3">
        <div class="row">
          <div class="col-8 pr-0">
            <fieldset class="fieldset-impressao">
              <legend>DATA DA CELEBRAÇÃO DO CASAMENTO OU, SE FOR O CASO DE CONVERSÃO DA UNIÃO ESTÁVEL, DATA DO REGISTRO.</legend>
              <span class="bold">{{ data.dados.datas.data_casamento_extenso || 'NÃO CONSTA' }}</span>
            </fieldset>
          </div>
          <div class="col-4 d-inline-flex justify-content-between pl-0">
            <div class="col-4 m-0 p-0">
              <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                <legend class="text-center">
                  DIA
                </legend>
                <span class="bold">{{ (`${data.dados.datas.casamento_dia}`.length == 1 && '0' + data.dados.datas.casamento_dia || data.dados.datas.casamento_dia) || 'N/C' }}</span>
              </fieldset>
            </div>
            <div class="col-4 m-0 p-0">
              <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                <legend class="text-center">
                  MÊS
                </legend>
                <span class="bold">{{ (`${data.dados.datas.casamento_mes}`.length == 1 && '0' + data.dados.datas.casamento_mes || data.dados.datas.casamento_mes) || 'N/C' }}</span>
              </fieldset>
            </div>
            <div class="col-4 m-0 p-0">
              <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                <legend class="text-center">
                  ANO
                </legend>
                <span class="bold">{{ (`${data.dados.datas.casamento_ano}`.length == 1 && '0' + data.dados.datas.casamento_ano || data.dados.datas.casamento_ano) || 'N/C' }}</span>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
      
      <div class="impressao_casamento--regime">
        <div class="row">
          <div class="col-12">
            <fieldset class="fieldset-impressao">
              <legend>REGIME DE BENS</legend>
              <span class="bold">{{ data.dados.regime.startsWith('Outros, ') ? data.dados.regime.substring(8) : data.dados.regime }}</span>
            </fieldset>
          </div>
        </div>
      </div>

      <div class="impressao_casamento--datas">
        <div class="row">
          <div class="col-8 pr-0">
            <fieldset class="fieldset-impressao">
              <legend>DATA DE REGISTRO DO CASAMENTO</legend>
              <span class="bold">{{ data.dados.datas.data_registro_extenso || 'NÃO CONSTA' }}</span>
            </fieldset>
          </div>
          <div class="col-4 d-inline-flex justify-content-between pl-0">
            <div class="col-4 m-0 p-0">
              <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                <legend class="text-center">
                  DIA
                </legend>
                <span class="bold">{{ (`${data.dados.datas.dia}`.length == 1 && '0' + data.dados.datas.dia || data.dados.datas.dia) || 'N/C' }}</span>
              </fieldset>
            </div>
            <div class="col-4 m-0 p-0">
              <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                <legend class="text-center">
                  MÊS
                </legend>
                <span class="bold">{{ (`${data.dados.datas.mes}`.length == 1 && '0' + data.dados.datas.mes || data.dados.datas.mes) || 'N/C' }}</span>
              </fieldset>
            </div>
            <div class="col-4 m-0 p-0">
              <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                <legend class="text-center">
                  ANO
                </legend>
                <span class="bold">{{ (`${data.dados.datas.ano}`.length == 1 && '0' + data.dados.datas.ano || data.dados.datas.ano) || 'N/C' }}</span>
              </fieldset>
            </div>
          </div>
        </div>
      </div>

      <div class="impressao_casamento--averbacoes-anotacoes">
        <div class="row">
          <div class="col-12">
            <fieldset class="fieldset-normal">
              <legend>ANOTAÇÕES / AVERBAÇÕES</legend>
              <span v-if="data.averbacoes_anotacoes && data.averbacoes_anotacoes.length <= 420 "
                    class="text-justify text-break"
                    v-html="data.averbacoes_anotacoes" />
              <span v-if="data.averbacoes_anotacoes && data.averbacoes_anotacoes.length > 420 "
                    class="text-justify bold"
                    v-html="'VIDE VERSO.'" />
              <span v-if="!data.averbacoes_anotacoes "
                    class="text-justify bold"
                    v-html="'NÃO CONSTA'" />
            </fieldset>
          </div>
        </div>
      </div>
      <div class="impressao_casamento--anotacoes-cadastro">
        <div class="row">
          <div class="col-12">
            <fieldset class="fieldset-impressao">
              <legend>ANOTAÇÕES VOLUNTÁRIAS DE CADASTRO</legend>
              <span class="bold">{{ data.anotacoes.length && 'VIDE VERSO.' || 'NÃO CONSTA' }}</span>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <!-- MESMO RODAPÉ DA CERTIDÃO DE ÓBITO E NASCIMENTO -->
    <b-row class="impressao_documento--rodape mt-3 text-center">
      <b-col cols="5"
             class="font--8 pr-1">
        <div style="white-space: nowrap;">
          Oficial de Registro Civil das Pessoas Naturais
          <br>
          {{ data.cartorio && data.cartorio.nome || 'NÃO CONSTA' }} - {{ data.cartorio && data.cartorio.endereco ? data.cartorio.endereco.uf : 'N/C' }}
        </div>
        <div class="mt-2">
          {{ data.oficial || 'NÃO CONSTA' }} - Oficial
        </div>
        <div v-if="data.cartorio"
             class="mt-2">
          {{ data.cartorio.endereco && data.cartorio.endereco.logradouro || 'NÃO CONSTA' }}, nº {{ data.cartorio.endereco && data.cartorio.endereco.numero || 'NÃO CONSTA' }} - {{ data.cartorio.endereco && data.cartorio.endereco.bairro || 'NÃO CONSTA' }}
          CEP: {{ data.cartorio.endereco && data.cartorio.endereco.cep || 'NÃO CONSTA' }} - Fone: {{ data.cartorio.telefone || 'NÃO CONSTA' }}
          <br>e-mail: {{ data.cartorio.email || 'NÃO CONSTA' }}
        </div>
      </b-col>
      <b-col>
        <div>
          O Conteúdo da certidão é verdadeiro. Dou fé.
        </div>
        <div v-if="data.cartorio">
          {{ data.cartorio.endereco && data.cartorio.endereco.cidade || 'NÃO CONSTA' }} - {{ data.cartorio.endereco && data.cartorio.endereco.uf || 'N/C' }}, {{ data.data_atual || 'NÃO CONSTA' }}.
        </div>
        <div>
          <hr class="hr--assinatura">
          <div class="d-inline-flex">
            {{ data.assinante.nome || 'NÃO CONSTA' }} - {{ data.assinante.cargo || 'NÃO CONSTA' }}
          </div>
        </div>
        <div class="mt-1">
          <div v-if="data.emolumentosFiltrados && !data.emolumentosFiltrados[data.emolumentosFiltrados.length - 1].valor.match('0,00')">
            Valor pago por essa certidão:<br>
            <span v-for="(emolumento, index) in data.emolumentosFiltrados"
                  :key="`emolumento_${ _uid }_${ index }`">
              <br v-if="emolumento.destino == 'Total' || emolumento.destino == 'AVERBAÇÕES'">
              <b v-if="emolumento.destino == 'Total'">{{ emolumento.destino }}: {{ emolumento.valor }};</b>
              <span v-else>{{ emolumento.destino }}: {{ emolumento.valor }};</span>
            </span>
          </div>

          <div v-if="!data.emolumentosFiltrados || !!data.emolumentosFiltrados[data.emolumentosFiltrados.length - 1].valor.match('0,00')">
            <b>{{ destino.primeiraVia ? '1ª' : '2ª' }} VIA ISENTA DE EMOLUMENTOS</b>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
/* image */
  import qrCodeImg from '@/assets/img/qrcode.png'

  //Filters
  import { maskCPF } from '@/filters/filters'

  export default {
    name: 'FrenteImpressaoCasamento',
    props: {
      propCasamento: {type: Object, default: () => ({})}
    },
    data () {
      return {
        qrCodeImg,
        data: this.propCasamento,
        destino: {
          primeiraVia: false,
          segundaVia: false
        }
      }
    },
    watch: {
      propCasamento () {
        this.data = {...this.propCasamento}

        // Atualiza destino
        this.destino = { primeiraVia: false, segundaVia: false }

        if (!this.data.ordemServicoSelected) return

        const osSelected = this.data.ordemServicoSelected

        if (!osSelected) return

        // Selecionado o item da OS com o selo selecionado
        const itemOsSelecionado = osSelected.itens.find(itemOS => {
          return itemOS.seloItemOs.find(seloItem => seloItem.selo.num_selo === this.data.selo.selo_digital)
        })

        // Verifica se o item da OS está com valor zerado
        const osComItemZerado = itemOsSelecionado && itemOsSelecionado.valor === 0

        // Valida OS e com item zerado
        if (!osSelected || !osSelected.itens.length || (osSelected.valor_total > 0 && !osComItemZerado)) return

        const primeiraVia = osSelected.itens.find(item => {
          return !item.flag_cancelado ? item.custa.codigo === 4 || item.custa.codigo === 5 || item.custa.codigo === 18 : item.custa.codigo === 16 || item.custa.codigo === 19 // AN e AO
        })

        const segundaVia = osSelected.itens.find(item => {
          return !item.flag_cancelado ? item.custa.codigo !== 4 && item.custa.codigo !== 5 && item.custa.codigo !== 18 : item.custa.codigo !== 16 && item.custa.codigo !== 19
        })

        if (primeiraVia) {
          this.destino = { primeiraVia: true, segundaVia: false }
        } else if (segundaVia) {
          this.destino = { primeiraVia: false, segundaVia: true }
        }
      }
    },
    methods: {
      maskCPF (cpf) {
        return maskCPF(cpf)
      }
    }
  }
</script>
<style lang="scss">
  .impressao_casamento {
    padding: 97px 90px;

    &--selo {
      font-size: 11px;
    }

    &--title {
      font-weight: 800 !important;
      font-size: 24px !important;
      font-family: Arial;
      text-align: center;
    }
  }

  .qrcode {
    width: 100px;
  }

  .fieldset-no-legend {
    height: 14px;
    padding: 4px 0 2px 0 !important;
    padding-left: 10px !important;
    margin-top: 6px;
    font-size:10px;
    text-transform: uppercase;
  }

  .municipio_nascimento {
    width: 99.5%;

    &_uf {
      width: 53%;
      margin-left: 1.1rem !important;
    }
  }
</style>
